import React from "react";
import { toast } from "react-toastify";
import { Box, Button, Divider } from "@mui/material";
import { Add } from "@mui/icons-material";



import FormDrawer from "components/Shared/FormDrawer";
import LegNoteList from "./LegNoteList";
import LegNoteForm from "./LegNoteForm";
import { useLegDetailContext } from "contexts/LegDetailContext";
import { useAddLegNoteMutation } from "store/services/legApi";

const LegNotesTab = () => {
  const [showNoteForm, setShowNoteForm] = React.useState(false);
  const [selectedNote, setSelectedNote] = React.useState(null);

  const { legDetail } = useLegDetailContext(); 

  const [addNote, { isLoading: addingNote }] = useAddLegNoteMutation();

  const handleCancelNote = () => {
    setShowNoteForm(false);
    setSelectedNote(null);
  };

  const handleAddNote = async (data) => {
    try {
      await addNote({ ...data, legId: legDetail?._id }).unwrap();
      toast.success("Note added successfully!");
      handleCancelNote();
    } catch (err) {
      toast.error(err?.data?.message || "Failed to add note!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showNoteForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowNoteForm(true)}
          >
            Add Note
          </Button>
        )}
      </Box>

      <Divider />

      {/* Note List */}
      <LegNoteList/>

      {/* Drawer Form */}
      <FormDrawer
        title="Leg Notes"
        open={showNoteForm}
        onClose={handleCancelNote}
      >
        <LegNoteForm
          isBusy={addingNote}
          note={selectedNote}
          onSubmit={handleAddNote}
          onCancel={handleCancelNote}
        />
      </FormDrawer>
    </>
  );
};

export default LegNotesTab;
